import { Component, Input } from '@angular/core';
import { ColumnSettings } from '../../common/models';

@Component({
    selector: 'boolean-viewer',
    templateUrl: './boolean-viewer.component.html',
    styleUrls: ['./boolean-viewer.component.scss'],
})
export class BooleanViewerComponent {
  @Input('record') record: any;
  @Input('column') column!: ColumnSettings;
}
